import { useQueryClient, useMutation } from 'react-query';
import uniqueId from 'lodash/uniqueId';
import merge from 'lodash/merge';
import { SuiNotification } from '@splashthat/sui';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import { useNotificationManager } from 'common/compounds/NotificationManager';
import { CHECK_IN_TOKEN_ERROR_MESSAGE } from 'common/constants/virtualEvent';
import useVirtualSettingsAttendeeApiClient from './useVirtualSettingsAttendeeApiClient';

const bootstrap = getBootstrap();
const eventId = parseInt(bootstrap.get('event.id', null), 10);
/**
 * This hook is used to generate a mutation function that will be used to checkin our guests.
 *
 * @param {Object{ vepTokens, setVepTokens }} props - A props list with the current VEP tokens.
 * @return {Object} checkInMutation - A react query check in mutation.
 */
const useCheckInMutation = ({ vepTokens, setVepTokens, eventSettings }) => {
    const notificationManager = useNotificationManager();
    const queryClient = useQueryClient();
    const virtualEventSettingsAPI = useVirtualSettingsAttendeeApiClient({ vepTokens });

    return useMutation(
        async () =>
            virtualEventSettingsAPI.putVirtualEventCheckIn(eventId, {
                'check-in-token': vepTokens?.checkInToken,
            }),
        {
            onSuccess: (data) => {
                if (data.success) {
                    setVepTokens({
                        ...vepTokens,
                        checkInToken: data?.data?.checkin_token,
                    });
                    queryClient.setQueryData(['eventSettings', eventId], merge({ data: eventSettings }, data));
                }
            },
            onError: (error) => {
                setVepTokens({ ...vepTokens, checkInToken: null });

                notificationManager.showNotification({
                    id: uniqueId('VEP_REQUEST_PUT_CHECKIN_ERROR_'),
                    message: CHECK_IN_TOKEN_ERROR_MESSAGE,
                    variation: SuiNotification.ERROR,
                });
            },
        },
    );
};

export default useCheckInMutation;
